function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    async: false,
    dataType: 'json',
    success: function() {
      alert("Product has been added!");
    }
  });
}


/*Function to redirect without a tag on Click*/  

function reDirectButton (buttonLink, e) {
    e.preventDefault();
    window.location.href = buttonLink;
    console.log(buttonLink)
  return
  }

function displayMembershipPopup (variantprice) {
sessionStorage["PopupShown"] = 'yes';
  console.log(variantprice)
        $("body").css("overflow","hidden");
        $('.ccmpl_overlay').css("display", "block");
        $('.ccmpl_modal_container').css("display", "block");

  $(".ccmpl_modal_total_price").html("$"+variantprice);
  $(".ccmpl_modal_membership_price").html("$"+parseFloat(variantprice*0.8).toFixed(2));
  $(".ccmpl_modal_saved_price").html("$"+parseFloat(variantprice*0.2).toFixed(2));
  return
}

function stickyATCsync (isMember) {
  console.log(isMember)
    actualPrice = $('.ccsa_select').find(":selected").attr("data-priceraw");
    $('.ccsa_input').val($('.ccsa_select').find(":selected").val());
  if (isMember){
    $('.ccsa_price').html($('.ccsa_select').find(":selected").attr('data-memprice'));
    $('.ccsa_price_compare').html($('.ccsa_select').find(":selected").attr('data-price'));
} else {
    $('.ccsa_price').html($('.ccsa_select').find(":selected").attr('data-price'));
    $('.ccsa_price_compare').html($('.ccsa_select').find(":selected").attr('data-compare'));
}
    let ccsaAvailability = $('.ccsa_select').find(":selected").attr('data-available');
    let ccsaQty = $('.ccsa_select').find(":selected").attr('data-qty');
    if (ccsaAvailability == "true") {
      $('.ccsa_submit').prop('disabled', false);
      if (ccsaQty < 1) {
      $('.ccsa_submit_text').html("Pre-Order");
      } else {
      $('.ccsa_submit_text').html("Add to Cart");
      }
    } else {
      $('.ccsa_submit').prop('disabled', true);
      $('.ccsa_submit_text').html("Sold out");
    }
  return
}